export default function vanceCashV2(fetch, baseUrl) {
  return {
    getReferenceTypes() {
      return fetch.get(`${baseUrl}/get-reference-types`);
    },
    getAllTransactionsV2({ walletType, userId, adjCnt }) {
      return fetch.get(
        `${baseUrl}/${walletType}?user_id=${userId}&adj_cnt=${adjCnt}`
      );
    },
    credit({ requestBody, walletType }) {
      return fetch.post(`${baseUrl}/${walletType}/credit`, requestBody);
    },
    debit({ requestBody, walletType }) {
      return fetch.post(`${baseUrl}/${walletType}/debit`, requestBody);
    }
  };
}
